<template>
  <div class="nav-footer">
    <!-- 定宽布局 -->
    <div class="container">
      <!-- 左侧 导航区块 -->
      <div class="f-list">
        <h2>网站导航</h2>
        <a href="/">首页</a>
        <a href="/#/ac1">图书信息</a>
        <a href="/#/ac2">文化资讯</a>
        <a href="/#/ac3">摄影资讯</a>
      </div>
      <!-- 中间  联系我们区块 -->
      <div class="f-info">
        <h2>联系我们</h2>
        <ul>
          <li>公司：北京学灯教育科技有限公司</li>
          <li>电话：13520625251</li>
          <li>地址：北京市通州区榆西一街1号院4号楼6层602室63642</li>
          <li>
            <a href="https://beian.miit.gov.cn/#/Integrated/index">备案号:京ICP备2023003070号-1</a>
          </li>
        </ul>
      </div>
      <!-- 右侧 关于我们区块 公司名 + 简介 -->
      <div class="f-jj">
        <!-- <img src="/imgs/logo.png" alt="" /> -->
        <p>
          经营范围包括一般项目：技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；计算机系统服务；软件开发；专业设计服务；数据处理服务；图文设计制作；社会经济咨询服务；组织文化艺术交流活动；文艺创作；企业管理咨询；教育咨询服务等...
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.nav-footer {
  width: 100%;
  height: 250px;
  background: #292f32;
  // margin-top: 40px;
  .container {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // 左侧导航
    .f-list {
      h2 {
        font-size: 14px;
        color: #fff;
        margin-bottom: 15px;
      }
      // 导航区块
      a {
        display: block;
        width: 60px;
        height: 20px;
        font-size: 14px;
        color: #fff;
        margin: 5px 0;
      }
    }
    // 中间联系我们
    .f-info {
      h2 {
        font-size: 14px;
        color: #fff;
      }
      ul {
        li {
          font-size: 12px;
          color: #fff;
          margin: 15px 0;
          a {
            font-size: 12px;
            color: #fff;
          }
        }
      }
    }
    // 右侧简介
    .f-jj {
      width: 300px;
      //   height: 100%;
      text-align: center;
      img {
        width: 200px;
        height: 80px;
        margin: 0 auto;
        background-color: #fff;
      }
      P {
        text-indent: 15px;
        font-size: 12px;
        color: #fff;
        margin: 15px auto;
        text-align: left;
      }
    }
  }
}
</style>
